export default "__VITE_PUBLIC_ASSET__70fe9be4__"